var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { Alert, AlertTitle, Snackbar as MaterialSnackbar } from "@mui/material";
const defaultProps = {
    "data-testid": "tecma-snackbar",
    variant: "filled",
};
const Snackbar = (_a) => {
    var { className, alertClassName, open, handleClose, key, hideDuration, children, severity, variant, alertClasses, sx, title } = _a, props = __rest(_a, ["className", "alertClassName", "open", "handleClose", "key", "hideDuration", "children", "severity", "variant", "alertClasses", "sx", "title"]);
    const classList = classNames("tecma-snackbar", className);
    const alertClassList = classNames("tecma-alert", alertClassName);
    return (_jsx(MaterialSnackbar, Object.assign({ open: open, onClose: handleClose, autoHideDuration: hideDuration, className: classList, anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
        } }, props, { children: _jsxs(Alert, { onClose: handleClose, className: alertClassList, classes: alertClasses, severity: severity, variant: variant, sx: sx, children: [title && _jsx(AlertTitle, { children: title }), children] }) }), key));
};
Snackbar.defaultProps = defaultProps;
export default React.memo(Snackbar);
